// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1ccaQ","icon":"styles_icon__1Nj0y"};